/** @graphql cc **/

import gql from 'graphql-tag';

export const UserProfileClientForConfluenceQuery = gql`
	query UserProfileClientForConfluenceQuery($userId: ID) {
		user: confluence_atlassianUser(current: false, id: $userId) {
			id
			confluence {
				permissionType
			}
		}
		entitlements {
			externalCollaborator {
				isEntitled
			}
		}
	}
`;
